import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-12">
        {/* Hero Section */}
        <section className="py-20 bg-sage-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-4xl md:text-5xl font-canela font-light text-gray-900 mb-6"
            >
              About Katie
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-xl text-gray-700 font-inter leading-relaxed"
            >
              Helping women navigate divorce with compassion, clarity, and confidence
            </motion.p>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                <img
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758557945515-headshot.jpg"
                  alt="Katie - Divorce Coach"
                  className="w-full h-128 object-cover rounded-lg shadow-lg"
                />
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="space-y-6"
              >
                <h2 className="text-3xl font-canela font-light text-gray-900">
                  My Story
                </h2>
                
                <div className="space-y-4 text-gray-700 font-inter leading-relaxed">
                  <p>
                    My journey into divorce coaching began with my own experience navigating the complex emotions and decisions that come with ending a marriage. Like many women, I felt overwhelmed, uncertain, and often alone during this challenging time.
                  </p>
                  
                  <p>
                    What I discovered through my own healing process was the transformative power of having someone to talk to who truly understood what I was going through. Someone who could offer both practical guidance and emotional support without judgment.
                  </p>
                  
                  <p>
                    This experience inspired me to become a certified divorce coach, specializing in helping women process their emotions, gain clarity on their situation, and create a plan for their future. I believe that with the right support, divorce can be a catalyst for positive change and personal growth.
                  </p>
                </div>

                <h3 className="text-2xl font-canela font-light text-gray-900 mt-8">
                  My Approach
                </h3>
                
                <div className="space-y-4 text-gray-700 font-inter leading-relaxed">
                  <p>
                    I work with women who are considering divorce, going through the process, or adjusting to life after divorce. My approach combines practical guidance with emotional support, helping you:
                  </p>
                  
                  <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>Process difficult emotions in a safe, non-judgmental space</li>
                    <li>Gain clarity on your values and priorities</li>
                    <li>Develop communication and boundary-setting skills</li>
                    <li>Create a vision for your future and actionable steps to get there</li>
                    <li>Build confidence and resilience during this transition</li>
                  </ul>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;